import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCastConnecting = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "currentColor",
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", {
			className: "frame-1",
			children: /* @__PURE__ */ _jsx("path", { d: "M25 7H7C5.9 7 5 7.9 5 9V12H7V9H25V23H18V25H25C26.1 25 27 24.1 27 23V9C27 7.9 26.1 7 25 7Z" })
		}),
		/* @__PURE__ */ _jsxs("g", {
			className: "frame-2",
			children: [/* @__PURE__ */ _jsx("path", { d: "M7 7H25C26.1 7 27 7.9 27 9V23C27 24.1 26.1 25 25 25H18V23H25V9H7V12H5V9C5 7.9 5.9 7 7 7Z" }), /* @__PURE__ */ _jsx("path", { d: "M5 25V22C6.66 22 8 23.34 8 25H5Z" })]
		}),
		/* @__PURE__ */ _jsx("g", {
			className: "frame-3",
			children: /* @__PURE__ */ _jsx("path", { d: "M25 7H7C5.9 7 5 7.9 5 9V12H7V9H25V23H18V25H25C26.1 25 27 24.1 27 23V9C27 7.9 26.1 7 25 7ZM5 22V25H8C8 23.34 6.66 22 5 22ZM5 18V20C7.76 20 10 22.24 10 25H12C12 21.13 8.87 18 5 18Z" })
		}),
		/* @__PURE__ */ _jsx("g", {
			className: "frame-4",
			children: /* @__PURE__ */ _jsx("path", { d: "M25 7H7C5.9 7 5 7.9 5 9V12H7V9H25V23H18V25H25C26.1 25 27 24.1 27 23V9C27 7.9 26.1 7 25 7ZM5 22V25H8C8 23.34 6.66 22 5 22ZM5 18V20C7.76 20 10 22.24 10 25H12C12 21.13 8.87 18 5 18ZM5 14V16C9.97 16 14 20.03 14 25H16C16 18.92 11.07 14 5 14Z" })
		})
	]
});
export { SvgCastConnecting as ReactComponent };
